import React from 'react';

const EndUserDataDeletionPage: React.FC = () => {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8 font-sans flex-1 text-white">
      <div className="max-w-3xl mx-auto p-8 sm:p-12">
        <h1 className="text-3xl font-bold mb-6 text-white tracking-tight">Solicitud de Eliminación de Datos de Usuario / Paciente</h1>
        
        <div className="space-y-8 text-white/90 leading-relaxed">
          <section>
            <p className="text-lg text-white font-medium">
              Respetamos tu privacidad y te ofrecemos una forma sencilla de solicitar la eliminación de tus datos personales recopilados a través de nuestras integraciones con clínicas en Instagram, Facebook y WhatsApp.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-white tracking-wide">Proceso de gestión manual por operador</h2>
            <p className="mb-4">
              Para garantizar la seguridad y correcta eliminación de tus datos, todas las solicitudes de eliminación son procesadas de forma manual por nuestro equipo de soporte técnico y operaciones.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-white tracking-wide">Pasos para solicitar la eliminación de datos</h2>
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                <strong>Paso 1:</strong> Envía un correo electrónico a nuestro equipo de soporte a <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL || 'contacto@taratic.com'}`} className="text-blue-400 hover:text-blue-300 underline underline-offset-2 font-medium">{import.meta.env.VITE_SUPPORT_EMAIL || 'contacto@taratic.com'}</a>.
              </li>
              <li>
                <strong>Paso 2:</strong> Asegúrate de que el asunto del correo sea exactamente: <br />
                <code className="bg-white/10 text-purple-300 px-2.5 py-1 rounded-lg text-sm mt-1 inline-block font-mono">Solicitud de Eliminación de Datos - Meta/Instagram</code>
              </li>
              <li>
                <strong>Paso 3:</strong> En el cuerpo del mensaje, debes incluir la siguiente información obligatoria para poder procesar tu solicitud:
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Nombre completo.</li>
                  <li>Correo electrónico registrado o utilizado de contacto.</li>
                  <li>El ID de usuario de Meta/Instagram (username) o el número de teléfono (en caso de WhatsApp).</li>
                  <li>El nombre exacto de la clínica o comercio asociado con el que interactuaste.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-white tracking-wide">Procedimiento del Operador</h2>
            <p className="mb-3">
              Una vez recibida la solicitud, un operador de nuestro equipo llevará a cabo el siguiente procedimiento:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Validará la identidad del solicitante utilizando los datos proporcionados.</li>
              <li>Procederá a la baja y purga completa y definitiva de los datos personales (PII) de nuestros servidores.</li>
              <li>Eliminará cualquier token de acceso de Meta asociado, así como el historial íntegro de conversaciones de nuestra base de datos.</li>
            </ul>
            <p className="mt-4 font-medium text-white">
              El plazo máximo para que el operador complete este proceso de eliminación es de <strong>30 días naturales</strong> desde la confirmación de recepción de la solicitud.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-3 text-white tracking-wide">Notificación de Confirmación</h2>
            <p>
              Una vez que el operador haya completado la purga completa de tus datos de nuestros sistemas, se te enviará un <strong>correo electrónico de confirmación final</strong> indicando que el proceso ha concluido satisfactoriamente.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default EndUserDataDeletionPage;
